import { AddCircleIcon, GroupsIcon, RocketIcon } from '@/assets/icons'
import PageLoader from '@components/PageLoader'
import TripCard from '@components/TripCard'
import { Trip } from '@types'
import React from 'react'
import {
    EmptyState,
    EmptyStateButton,
    EmptyStateButtons,
    EmptyStateContainer,
    EmptyStateIcon,
    EmptyStateText,
    ErrorState,
    HeaderActions,
    HeaderButton,
    TripsGrid,
    TripsListContainer,
    TripsListHeader,
    TripsListTitle,
} from './TripsList.styles'

interface TripsListProps {
	trips: Trip[]
	loading: boolean
	error: string | null
	onTripClick: (trip: Trip) => void
	onCreateTrip: () => void
	onJoinTrip: () => void
}

const TripsList: React.FC<TripsListProps> = ({
	trips,
	loading,
	error,
	onTripClick,
	onCreateTrip,
	onJoinTrip,
}) => {
	if (loading) {
		return (
			<TripsListContainer>
				<PageLoader label="Loading your trips…" />
			</TripsListContainer>
		)
	}

	if (error) {
		return (
			<TripsListContainer>
				<ErrorState>
					<strong>Error loading trips:</strong> {error}
				</ErrorState>
			</TripsListContainer>
		)
	}

	// Show empty state when there are no trips
	if (trips.length === 0) {
		return (
			<TripsListContainer>
				<EmptyStateContainer>
					<EmptyState>
						<EmptyStateIcon>
							<RocketIcon width={128} height={128} fill="currentColor" />
						</EmptyStateIcon>
						<EmptyStateText>You aren't in any trips yet. Create or join one below to get started.</EmptyStateText>
						<EmptyStateButtons>
							<EmptyStateButton onClick={onCreateTrip}>
								<AddCircleIcon width={20} height={20} fill="currentColor" />
								<span>Create Trip</span>
							</EmptyStateButton>
							<EmptyStateButton onClick={onJoinTrip}>
								<GroupsIcon width={20} height={20} fill="currentColor" />
								<span>Join Trip</span>
							</EmptyStateButton>
						</EmptyStateButtons>
					</EmptyState>
				</EmptyStateContainer>
			</TripsListContainer>
		)
	}

	return (
		<TripsListContainer>
			<TripsListHeader>
				<TripsListTitle>My Trips</TripsListTitle>
				<HeaderActions>
					<HeaderButton onClick={onCreateTrip}>
						<AddCircleIcon width={20} height={20} fill="currentColor" />
						<span>Create Trip</span>
					</HeaderButton>
					<HeaderButton onClick={onJoinTrip}>
						<GroupsIcon width={20} height={20} fill="currentColor" />
						<span>Join Trip</span>
					</HeaderButton>
				</HeaderActions>
			</TripsListHeader>

			<TripsGrid>
				{trips.map(trip => (
					<TripCard key={trip.id} trip={trip} onClick={onTripClick} />
				))}
			</TripsGrid>
		</TripsListContainer>
	)
}

export default TripsList
